import React, { useState } from 'react';
import { postSolicitudAnulacionOrdenApi } from "../../../api/axios";
import { idEstadosOrden } from "../../../helper/ordenHelper";
import ModalItem from "../../General/Modal";
import { toast } from "react-toastify";

export default function SolicitudAnulacion({
  idEstado,
  idOrden,
  idSeller,
  motivoSolicitudOrden,
  motivosAnulacion = [],
  goToOrdenes
}) {
  const solicitudEnviada = idEstado === idEstadosOrden.solicitarAnulacion;
  const [idMotivoAnulacion, setIdMotivoAnulacion] = useState(motivoSolicitudOrden?.idMotivo ?? "");
  const [isUpdating, setIsUpdating] = useState(false);

  const handleMotivoAnulacion = (e) => {
    const { value } = e.target;
    setIdMotivoAnulacion(value);
  };

  const postSolicitudAnulacion = () => {
    const request = {
      idVenta: idOrden,
      idSeller: idSeller,
      solicitarAnulacion: true,
      idMotivoAnulacion: parseInt(idMotivoAnulacion)
    }

    setIsUpdating(true);
    let req = postSolicitudAnulacionOrdenApi(request);
    req.then(res => {
      toast.success("Solicitud de anulación enviada");
      goToOrdenes();
    }).catch(err => {
      toast.warning("No se pudo enviar la solicitud");
    }).finally(() => {
      setIsUpdating(false);
    });
  };

  const isValidSolicitud = () => {
    if (!idMotivoAnulacion) {
      toast.warn("Seleccione un motivo de anulación");
      return false;
    }
    return true;
  };

  return (
    <div className="row mb-3">

      <div className="col-12 col-sm-auto">
        <ModalItem
          disabled={isUpdating || solicitudEnviada}
          text={"¿Desea solicitar la anulacion de esta orden?"}
          onDelete={postSolicitudAnulacion}
          validationHandler={isValidSolicitud}
          btnStyle="btn btn-sm background-rojo-megatone"
          btnText={"Solicitar Anulación"}
        />
      </div>

      {!solicitudEnviada &&
        <div className="form-group col-12 col-sm-auto">
          <label>Motivo de anulación</label>
          <select
            className="form-control"
            value={idMotivoAnulacion}
            onChange={handleMotivoAnulacion}
          >
            <option value={motivoSolicitudOrden?.id ?? ""}>{motivoSolicitudOrden?.descripcion}</option>
            {motivosAnulacion?.map((motivo, index) => (
              <option key={index} value={motivo.id}>{motivo.descripcion}</option>
            ))}
          </select>
        </div>
      }
    </div>
  )
}